import { Form, Input, InputNumber, Select, Space, Switch } from 'antd';
import SurveyGroupSelect from 'components/SurveyGroupSelect';
import React, { useEffect, useRef } from 'react';
import { SETTING_TYPES } from 'shared/constants/settings';
import SettingValue from './SettingValue';

const { BOOLEAN, NUMBER, ARRAY, SURVEY_GROUP_ID, PRICE, TEXT, OBJ } = SETTING_TYPES;

const PriceInput = ({ value, onChange }) => {
  const onChangeValue = (currency) => (v) => {
    onChange({ ...value, [currency]: v });
  };

  return (
    <Space>
      <InputNumber value={value?.SEK} onChange={onChangeValue('SEK')} prefix="SEK" style={{ width: 120 }} />
      <InputNumber value={value?.EUR} onChange={onChangeValue('EUR')} prefix="EUR" style={{ width: 120 }} />
      <InputNumber value={value?.USD} onChange={onChangeValue('USD')} prefix="USD" style={{ width: 120 }} />
    </Space>
  );
};

const EditSettingValue = (props) => {
  const { namePath, settingKey, setting } = props;
  const ref = useRef();
  let InputComponent = Input;
  let valuePropName = 'value';
  const inputProps = { ref, ...props.inputProps };

  switch (setting?.type) {
    case BOOLEAN:
      InputComponent = Switch;
      valuePropName = 'checked';
      break;
    case NUMBER:
      InputComponent = InputNumber;
      break;
    case SURVEY_GROUP_ID:
      InputComponent = SurveyGroupSelect;
      break;
    case ARRAY:
      InputComponent = null;
      break;
    case PRICE:
      InputComponent = PriceInput;
      inputProps.ref = undefined;
      break;
    case TEXT:
      if (setting?.options?.length) {
        InputComponent = Select;
        inputProps.options = setting.options;
      } else if (setting?.secret) {
        InputComponent = Input.Password;
      } else {
        InputComponent = Input.TextArea;
        inputProps.autoSize = { minRows: 3 };
      }
      break;
    case OBJ:
      InputComponent = Input.TextArea;
      inputProps.autoSize = { minRows: 3 };
      break;
    default:
      break;
  }

  useEffect(() => {
    ref.current?.focus({ cursor: 'all' });
  }, [ref.current]);

  return InputComponent ? (
    <Form.Item name={[...namePath, settingKey]} valuePropName={valuePropName}>
      <InputComponent {...inputProps} />
    </Form.Item>
  ) : <SettingValue setting={setting} />;
};

export default EditSettingValue;
